import { useAuthStore } from '../../store/authStore';
import { Navigate, useLocation } from 'react-router-dom';
import FarmLifecycleLoader from './FarmLifecycleLoader';

export default function ProtectedRoute({ children, allowedRoles }) {
  const { userProfile, loading } = useAuthStore();
  const location = useLocation();

  if (loading && !userProfile) {
    return <FarmLifecycleLoader compact title="Loading your Sedyam session" subtitle="Ploughing, planting, harvesting, and preparing your dashboard..." />;
  }

  // Not authenticated at all
  if (!userProfile) {
    const safeRoles = Array.isArray(allowedRoles) ? allowedRoles : [];
    const nonCustomerRoles = safeRoles.filter((role) => role !== 'customer');
    const onlyStaffRoles = nonCustomerRoles.length > 0 && nonCustomerRoles.length === safeRoles.length;
    const loginTarget = onlyStaffRoles
      ? (nonCustomerRoles.length === 1 ? `/org/${nonCustomerRoles[0]}` : '/org')
      : '/login';

    return (
      <Navigate
        to={loginTarget}
        replace
        state={{
          redirectTo: `${location.pathname}${location.search || ''}`,
          redirectState: location.state || null,
        }}
      />
    );
  }

  const role = userProfile?.role;

  if (!allowedRoles.includes(role)) {
    const dashMap = {
      farmer:     '/dashboard/farmer',
      dealer:     '/dashboard/dealer',
      delivery:   '/dashboard/delivery',
      supervisor: '/dashboard/supervisor',
      manager:    '/dashboard/manager',
      ceo:        '/dashboard/ceo',
      admin:      '/dashboard/admin',
      super_admin:'/dashboard/super-admin',
      customer:   '/',
    };
    return <Navigate to={dashMap[role] || '/'} replace />;
  }

  return children;
}
